import ToggleSwitch from './ToggleSwitch';
import DateRangePicker from './DateRangePicker';
import {
  FilterOptions,
  OrderDateRangeFilterProps,
} from '../interface/interface';

export default function OrderDateRangeFilter(props: OrderDateRangeFilterProps) {
  const handleToggleSwitch = (e: React.MouseEvent<HTMLDivElement>) => {
    const fromDate = localStorage.getItem('fromDate')
      ? new Date(localStorage.getItem('fromDate') as string)
      : null;
    const toDate = localStorage.getItem('toDate')
      ? new Date(localStorage.getItem('toDate') as string)
      : null;
    if ((e?.target as HTMLElement)?.textContent === 'Last Edited') {
      localStorage.setItem('filterBy', FilterOptions.UpdatedDate);
      props.filterProp.setter(FilterOptions.UpdatedDate);
      props.onExport(fromDate, toDate, FilterOptions.UpdatedDate);
    }
    if ((e?.target as HTMLElement)?.textContent === 'Ordered Date') {
      localStorage.setItem('filterBy', FilterOptions.CreatedDate);
      props.filterProp.setter(FilterOptions.CreatedDate);
      props.onExport(fromDate, toDate, FilterOptions.CreatedDate);
    }
  };

  return (
    <div className="flex items-center">
      <span className="text-grey-500 text-xs mr-3 align-middle ml-5">by</span>
      <ToggleSwitch
        option1="Ordered Date"
        option2="Last Edited"
        isChecked={
          localStorage.getItem('filterBy')
            ? localStorage.getItem('filterBy') === FilterOptions.UpdatedDate
            : props.filterProp.state === FilterOptions.UpdatedDate
        }
        onToggle={handleToggleSwitch}
        className="w-[250px]"
      />
      <div className="ml-5 flex items-center">
        <span className="text-grey-500 text-xs mr-3">between</span>
        <DateRangePicker
          onDateChange={(start, end) => {
            if (start && end) {
              props.onExport(start, end);
            }
            localStorage.setItem('fromDate', start ? start.toISOString() : '');
            localStorage.setItem('toDate', end ? end.toISOString() : '');
          }}
        />
      </div>
    </div>
  );
}
